module.exports = __webpack_public_path__ + "static/media/Logo1602g.7121bed4.png";